






































import mixins from 'vue-typed-mixins';
import { SurveyGroup } from '../../../utils/SurveyUtils';
export default mixins().extend({
  props: {
    value: {
      type: Object as () => SurveyGroup,
    },
    pristine: {
      type: Object as () => SurveyGroup,
    },
  },

  computed: {
    states() {
      if (this.pristine.state) {
        if (this.pristine.state == 'active') {
          return ['inactive', 'active', 'closed', 'archived'];
        } else if (this.pristine.state == 'inactive') {
          return ['inactive', 'active', 'archived'];
        } else if (this.pristine.state == 'archived') {
          return ['archived', 'inactive'];
        } else if (this.pristine.state == 'closed') {
          return ['closed', 'active', 'archived'];
        }
      } else {
        return ['inactive', 'active', 'closed', 'archived'];
      }
    },
  },

  methods: {
    submit() {
      this.$emit('submit', this.value);
    },
  },
});
